import React from 'react';
import {observer} from 'mobx-react';
import {AthleteLinkModel} from "../../../containers/athlete-container/models/athlete-link-model";
import {APP} from "../../../core/app/consts";
import {ACTION_TYPES} from "../../../core/consts";
import {FooterButtons} from "../../../core/components/footer-buttons/footer-buttons";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";

export const LivePenaltiesModuleFooterButtons = observer(({controller, onClose, competitionId}) => {
  const {state, terms: i18n, props} = controller;
  const {selectedAthlete, competitorVM, currentLinkModel} = state;
  const {gameId} = props;

  const footerProps = {
    controller,
    onClose: () => {
      controller.action(LIVE_PENALTIES.ACTION_TYPES.onClose, {
        gameId,
        competitorId: competitorVM.id,
        athleteId: selectedAthlete.id
      });

      onClose();
    },
    shouldRenderEntityButton: true,
    buttonLabel: selectedAthlete?.name || i18n.WEB_POP_STATS_PLAYER_DETAILS_BUTTON,
    buttonLinkModel: new AthleteLinkModel(selectedAthlete?.id, selectedAthlete?.sport?.nameForURL, selectedAthlete?.nameForURL, selectedAthlete?.isNational, competitionId, null, null, selectedAthlete?.isFollow),
    onClick: () => {
      controller.action(ACTION_TYPES.entityClick, {
        entityId: selectedAthlete?.athleteId,
        entityName: selectedAthlete?.nameForURL,
        entityType: APP.ANALYTICS.USER_SELECTIONS.TYPES.AthleteViewModel,
        source: APP.ANALYTICS.SOURCES.livePenalties,
        sportTypeId: selectedAthlete.sport.id,
        currentLinkModel
      })

      return true
    }
  }

  return <FooterButtons {...footerProps}/>
});
